import { createContext, useContext, useReducer, ReactNode } from 'react'

const ModalStateContext = createContext<any>( undefined )
const ModalDispatchContext = createContext<any>( undefined )

export const initialState = { selectedModal: undefined }

export function modalReducer( _state: any, action: any ) {
	switch ( action.type ) {
		case 'setSelectedModal':
			return { selectedModal: action.selectedModal }

		default:
			throw new Error( `ModalProvider unhandled action ${action.type}` )
	}
}

export function useModalState() {
	const state = useContext( ModalStateContext )

	if ( state === undefined ) {
		throw new Error( 'useModalState must be used within a ModalProvider' )
	}

	return state.selectedModal
}

export function useModalDispatch() {
	const dispatch = useContext( ModalDispatchContext )

	if ( dispatch === undefined ) {
		throw new Error( 'useModalDispatch must be used within a ModalProvider' )
	}

	return dispatch
}

export function useDispatchSetSelectedModal() {
	const dispatch = useModalDispatch()

	return ( selectedModal: any ) => dispatch( {
		type: 'setSelectedModal',
		selectedModal,
	} )
}

export type ModalProviderProps = {
	children: ReactNode,
}

export function ModalProvider( { children }: ModalProviderProps ) {
	const [ state, dispatch ] = useReducer( modalReducer, initialState )

	return (
		<ModalStateContext.Provider value={state}>
			<ModalDispatchContext.Provider value={dispatch}>
				{children}
			</ModalDispatchContext.Provider>
		</ModalStateContext.Provider>
	)
}
